module.exports = __webpack_public_path__ + "df106d96a5ee90893709552d2b0fa2fe.pdf";